import { EditMode } from "../state/uiState";
export function calcIsHighlighted(machineState, transitionId) {
    var _a, _b;
    const editMode = machineState.uiState.editMode;
    if (editMode === EditMode.EXECUTION) {
        return ((_b = (_a = machineState.executionState) === null || _a === void 0 ? void 0 : _a.lastTransition) === null || _b === void 0 ? void 0 : _b.id) === transitionId;
    }
    else if (editMode === EditMode.EXECUTION_TRANSITION) {
        return machineState.animation.transitionId === transitionId;
    }
    else {
        return machineState.uiState.selection.transitionId === transitionId;
    }
}
export function calcHighlightLineNr(machineState, transitionId) {
    var _a, _b;
    if (machineState.uiState.editMode === EditMode.EXECUTION) {
        const isLastUsedTransition = ((_b = (_a = machineState.executionState) === null || _a === void 0 ? void 0 : _a.lastTransition) === null || _b === void 0 ? void 0 : _b.id) === transitionId;
        if (isLastUsedTransition) {
            return machineState.executionState.lastCharIndex;
        }
        else {
            return -1;
        }
    }
    else if (machineState.uiState.editMode === EditMode.EXECUTION_TRANSITION) {
        const transitionIsUsed = machineState.animation.transitionId === transitionId;
        if (transitionIsUsed) {
            return machineState.animation.charIndex;
        }
        else {
            return -1;
        }
    }
    else {
        return -1;
    }
}
